import { ofType } from 'redux-observable'

import APP, { epicErrorHandler, epicResponseHandler, epicServerRequest, serverResponse } from 'app'

import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

export const RESET_FETCH = 'RESET_FETCH'
export const RESET_FETCH_ERROR = 'RESET_FETCH_ERROR'
export const RESET_FETCH_FULFILLED = 'RESET_FETCH_FULFILLED'
export const RESET_FETCH_CANCELED = 'RESET_FETCH_CANCELED'

export const getResetInitialState = serverResponse

export const resetFetch = (code, token) => ({
  payload: { code, token },
  type: RESET_FETCH,
})

export const resetFetchFulfilled = (payload) => ({
  payload,
  type: RESET_FETCH_FULFILLED,
})

export const resetFetchCanceled = () => ({
  payload: null,
  type: RESET_FETCH_CANCELED,
})

export const resetFetchError = (payload) => {
  let msg = ''
  let title = ''
  if (payload.error.code === 401) {
    title = 'Link no válido'
    msg = 'El link de cambio de clave no es válido o ha caducado'
  }

  Object.assign(payload.error, { msg })

  return {
    notification: {
      title,
    },
    payload,
    type: RESET_FETCH_ERROR,
  }
}

export const resetFetchEpic = (action$) =>
  action$.pipe(
    ofType(RESET_FETCH),
    mergeMap((action) =>
      epicServerRequest('post', `${APP.api_url}/user/reset`, action, action.payload).pipe(
        map(epicResponseHandler(resetFetchFulfilled, action)),
        takeUntil(action$.pipe(ofType(RESET_FETCH, RESET_FETCH_CANCELED))),
        catchError(epicErrorHandler(resetFetchError, action)),
      ),
    ),
  )
